import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import {
  ADD_DOCS_AND_FORMS_TO_MATTER,
  ADD_DOCS_AND_FORMS_TO_MATTER_FOLDER,
  ADD_DOCS_AND_FORMS_TO_MATTER_NEW_FOLDER,
} from './ADD_DOCS_AND_FORMS_TO_MATTER';
import { refetchListMatters } from 'pages/matters/useMatters';
import { useLazyMatterDocsAndFormsFoldersRefetch } from '../useMatterDocsAndForms';

export function useAddMatterItems(callback, group) {
  const [addItemsToMatter] = useMutation(ADD_DOCS_AND_FORMS_TO_MATTER);
  const [addItemsToMatterFolder] = useMutation(
    ADD_DOCS_AND_FORMS_TO_MATTER_FOLDER,
  );
  const [addItemsToMatterNewFolder] = useMutation(
    ADD_DOCS_AND_FORMS_TO_MATTER_NEW_FOLDER,
  );

  const refetchMatterDocsAndFormsVariables =
    useLazyMatterDocsAndFormsFoldersRefetch();

  const handleSave = useCallback(
    async ({ matter, folder }) => {
      const variables = {
        matterId: matter.id,
        folderId: folder?.id,
        folderName: folder?.name,
        items: group.map(item => ({
          type: 'TrueForm',
          contentfulId: item.contentfulId,
          docspringTemplateId: item.document.docspringTemplateId,
        })),
      };

      const response = await (
        folder
          ? folder.id
            ? addItemsToMatterFolder
            : addItemsToMatterNewFolder
          : addItemsToMatter
      )({
        variables,
        refetchQueries: [
          ...refetchListMatters,
          refetchMatterDocsAndFormsVariables(matter.id),
        ],
      });

      if (response?.data?.items) {
        callback(matter, response.data?.items);
      }
    },
    [
      callback,
      group,
      addItemsToMatter,
      addItemsToMatterFolder,
      addItemsToMatterNewFolder,
      refetchMatterDocsAndFormsVariables,
    ],
  );

  return handleSave;
}
